import * as React from 'react';
const SvgEdit = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            d="M9.886 4.698L3.7 10.89a1.5 1.5 0 00-.337.516l-1.536 2.777 2.77-1.541c.194-.076.37-.19.517-.338L11.3 6.12a5.786 5.786 0 00-1.414-1.422zm1.429-1.43c.53.41 1.007.888 1.416 1.42l1.11-1.108c.262-.262.254-.445-.36-1.06-.615-.614-.798-.622-1.06-.36l-1.106 1.107zM14.9 1.1c1.389 1.39 1.4 2.84.35 3.89l-8.72 8.728a3.5 3.5 0 01-1.206.787L1.71 15.91a1.25 1.25 0 01-1.618-1.618l1.406-3.612a3.5 3.5 0 01.786-1.205L11.01.75c1.05-1.05 2.502-1.038 3.89.35z"
            fill="currentColor"
        />
    </svg>
);
export default SvgEdit;
